import { Div } from 'alkali'
import UserMenu from './UserMenu'
import { HelpIcon } from './HelpIcon'
import { Shutdown } from './Shutdown'
import './Navbar.css'
export const Navbar = Div('.navbar', [
	HelpIcon,
	UserMenu,
	Shutdown,
])
